import { schema as objectiveRateType } from './ObjectiveRateType.schema';
import { schema as objectiveRepaymentType } from './ObjectiveRepaymentType.schema';
import { schema as objectiveProductType } from './ObjectiveProductType.schema';
import {
  assetFinanceSchema as objectiveNeedsAndObjectivesAssetFinance,
  homeLoanSchema as objectiveNeedsAndObjectivesHomeLoan
} from './ObjectiveNeedsAndObjectives.schema';
import {
  assetFinanceSchema as objectiveTermOfCreditSoughtAssetFinance,
  homeLoanSchema as objectiveTermOfCreditSoughtHomeLoan,
  loanworksSchema as objectiveTermOfCreditSoughtLoanworks
} from './ObjectiveTermOfCreditSought.schema';
import { schema as objectiveRequirementsAndObjectives } from './ObjectiveRequirementsAndObjectives.schema';
import { schema as objectivePossibleAdverseChangesToFinancialSituation } from './ObjectivePossibleAdverseChangesToFinancialSituation.schema';
import { schema as objectivePossibleBeneficialChangesToFinancialSituation } from './ObjectivePossibleBeneficialChangesToFinancialSituation.schema';
import { schema as objectiveExitStrategy } from './ObjectiveExitStrategy.schema';
import {
  assetFinanceSchema as objectiveFinancialSecurityAssetFinance,
  homeLoanSchema as objectiveFinancialSecurityHomeLoan
} from './ObjectiveFinancialSecurity.schema';
import {
  loanworksSchema as objectiveCreditHistoryLoanworks,
  homeLoanSchema as objectiveCreditHistoryHomeLoan,
  assetFinanceSchema as objectiveCreditHistoryAssetFinance
} from './ObjectiveCreditHistory.schema';
import { schema as objectiveProductRequirements } from './ObjectiveProductRequirements.schema';
import { schema as objectiveWhatIsImportantForYou } from './ObjectiveWhatIsImportantForYou.schema';

const productRequirementsSchema = (Joi: any) =>
  Joi.object().keys({
    rateType: objectiveRateType(Joi, 'Product requirements - Rate type - '),
    repaymentType: objectiveRepaymentType(Joi, 'Product requirements - Repayment type - '),
    productType: objectiveProductType(Joi, 'Product requirements - Product type - ')
  });

export const assetFinanceSchema = (Joi: any) =>
  Joi.object().keys({
    needsAndObjectives: objectiveNeedsAndObjectivesAssetFinance(
      Joi,
      'Needs and objectives - Comments - '
    ),
    productRequirements: objectiveProductRequirements(
      Joi,
      'Needs and objectives - Product requirements - '
    ),
    termOfCreditSought: objectiveTermOfCreditSoughtAssetFinance(
      Joi,
      'Needs and objectives - Term of credit sought - '
    ),
    possibleAdverseChangesToFinancialSituation: objectivePossibleAdverseChangesToFinancialSituation(
      Joi,
      'Needs and objectives - Possible adverse changes to financial situation - '
    ),
    financialSecurity: objectiveFinancialSecurityAssetFinance(
      Joi,
      'Needs and objectives - Financial security - '
    ),
    creditHistory: objectiveCreditHistoryAssetFinance(
      Joi,
      'Needs and objectives - Credit history - '
    )
  });

export const homeLoanSchema = (Joi: any) => {
  return productRequirementsSchema(Joi).keys({
    needsAndObjectives: objectiveNeedsAndObjectivesHomeLoan(
      Joi,
      'Needs and objectives - Comments - '
    ),
    requirementsAndObjectives: objectiveRequirementsAndObjectives(
      Joi,
      'Needs and objectives - Requirements and objectives - '
    ),
    exitStrategy: objectiveExitStrategy(Joi, 'Needs and objectives - Exit strategy - '),
    possibleAdverseChangesToFinancialSituation: objectivePossibleAdverseChangesToFinancialSituation(
      Joi,
      'Needs and objectives - Possible adverse changes to financial situation - '
    ),
    possibleBeneficialChangesToFinancialSituation: objectivePossibleBeneficialChangesToFinancialSituation(
      Joi,
      'Needs and objectives - Possible beneficial changes to financial situation - '
    ),
    financialSecurity: objectiveFinancialSecurityHomeLoan(
      Joi,
      'Needs and objectives - Financial security - '
    ),
    creditHistory: objectiveCreditHistoryHomeLoan(
      Joi,
      'Needs and objectives - Credit history - '
    ),
    termOfCreditSought: objectiveTermOfCreditSoughtHomeLoan(
      Joi,
      'Product requirements - Term of credit sought - '
    ),
    whatIsImportantForYou: objectiveWhatIsImportantForYou(
      Joi,
      'Product requirements - What is most important for you? - '
    )
  });
};

export const loanworksSchema = (Joi: any) =>
  productRequirementsSchema(Joi).keys({
    needsAndObjectives: objectiveNeedsAndObjectivesHomeLoan(
      Joi,
      'Needs and objectives - Comments - '
    ),
    requirementsAndObjectives: objectiveRequirementsAndObjectives(
      Joi,
      'Needs and objectives - Requirements and objectives - '
    ),
    termOfCreditSought: objectiveTermOfCreditSoughtLoanworks(
      Joi,
      'Product requirements - Term of credit sought - '
    ),
    creditHistory: objectiveCreditHistoryLoanworks(
      Joi,
      'Needs and objectives - Credit history - '
    ),
    exitStrategy: objectiveExitStrategy(Joi, 'Needs and objectives - Exit strategy - ')
  });

export default {
  assetFinanceSchema,
  homeLoanSchema,
  loanworksSchema
};
